<template>
  <div class="demand" :class="[page === 'confirmation' ? 'bg-yellow' : '']">

    <!-- タイトルと×ボタン -->
    <div
      class="demand-header"
      :class="[page === ('confirmation' || '3') ? 'tx-center' : '']"
    >
      <p :class="[isCenter ? 'center' : '']" v-html="title" />
      <a v-if="page == 'confirmation'" @click="ncDemandClose()" class="batsu"
        >×</a
      >
      <a v-else @click="backButtonClicked()" class="batsu">×</a>
    </div>

    <!-- ページ一表示バー -->
    <ul class="flow" v-if="page != 'confirmation'">
      <li :class="[page === '1' ? 'active' : '']">
        <label>行き先</label>
      </li>
      <li :class="[page === '2' ? 'active' : '']">
        <label>日時と人数</label>
      </li>
      <li :class="[page === '3' ? 'active' : '']">
        <label>決済方法</label>
      </li>
      <li :class="[page === '4' ? 'active' : '']">
        <label>確認</label>
      </li>
      <li :class="[page === '5' ? 'active' : '']">
        <label>完了</label>
      </li>
    </ul>

  </div>
</template>

<script>
import { useRouter } from "vue-router";
import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "TheDemandHeader",
  props: {
    page: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: false,
    },
    clickBackButtonEvent: {
      type: Function,
      required: false,
      default: null,
    },
    isCenter: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props) {
    const router = useRouter();

    const ncDemandClose = async() => {
      await nativeHandlerService.demand.ncDemandClose();
    }    

    const backButtonClicked = () => {
      if (props.clickBackButtonEvent) {
        props.clickBackButtonEvent();
      } else {
        router.push({
          name: "DemandIndex",
        });
      }
    }
    return{
      ncDemandClose,
      backButtonClicked
    }
  }

};
</script>

<style lang="scss" scoped>
.demand {
  margin-bottom: 10px;
}
.demand-header {
  height: 50px;
  position: relative;
  p {
    display: inline-block;
    width: 80%;
    font-size: 1rem;
    font-weight: bold;
    position: absolute;
    top: 50%;
    left: 10px;
    transform: translate(0%, -50%);
    -webkit-transform: translate(0%, -50%);
    -ms-transform: translate(0%, -50%);
  }
  .center {
    left: 50%;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    text-align: center;
  }
  .batsu {
    color: #000000;
    font-size: 1.2rem;
    text-decoration: none;
    padding: 10px;
    display: inline-block;
    font-size: 1.5rem;
    font-weight: 100;
    position: absolute;
    top: 45%;
    right: 10px;
    transform: translate(0%, -50%);
    -webkit-transform: translate(0%, -50%);
    -ms-transform: translate(0%, -50%);
  }
}

.demand ul.flow {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  padding: 0;
  background-color: #f0f0f0;
  list-style: none;
  font-size: 13px;
  font-weight: bold;
  height: 25px;
}

.demand ul.flow li {
  position: relative;
  height: 25px;
  margin-left: -15px;
  background-color: #f0f0f0;
  line-height: 26px;
  color: #999999;
}
.demand ul.flow li {
  width: calc(100% / 5 + 75px);
}

.demand ul.flow li label {
  position: absolute;
  width: calc(100% - 29px);
  padding-left: 14px;
  background-color: #e0e0e0;
  text-align: center;
  font-size: 10px;
  height: 25px;
}

.demand ul.flow li:after {
  position: absolute;
  display: block;
  z-index: 1;
  top: 0px;
  right: 6px;
  content: "";
  width: 23px;
  height: 23px;
  border-width: 1px 1px 0 0;
  border-style: solid;
  border-color: #ffffff;
  background: -webkit-linear-gradient(
    45deg,
    transparent 20px,
    #e0e0e0 1px,
    #e0e0e0 25px
  );
  transform: rotate(45deg);
}

.demand ul.flow li.active:after {
  background: -webkit-linear-gradient(
    45deg,
    transparent 20px,
    #ffb206 1px,
    #ffb206 25px
  );
}

.demand ul.flow li.active {
  color: #ffffff;
}

.demand ul.flow li.active label {
  background-color: #ffb206;
}
.tx-center {
  text-align: center;
}
.bg-yellow {
  background: #fdd002;
}
</style>
